module.exports = __webpack_public_path__ + "img/logo-white.83cd2106.png";